import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, effect, input, model, output, signal} from '@angular/core';

import {ApmTranslatePipe} from '@mitsubishi/core';
import {StatisticOption} from '@mitsubishi/project/data-access';
import {SectionTitleComponent} from '@mitsubishi/shared/ui';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'apm-statistic-data-item',
  templateUrl: './statistic-data-item.component.html',
  styleUrls: ['./statistic-data-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FaIconComponent, SectionTitleComponent, ApmTranslatePipe],
})
export class StatisticDataItemComponent {
  readonly title = input('');
  readonly statisticDataList = input<StatisticOption[]>([])
  readonly groupCode = input.required<string>();
  readonly selectedStatistics = input<Record<string, StatisticOption | null>>({});

  selectedStatisticsCode = signal<StatisticOption | null>(null);

  selectedStatisticCodeChanged = output<StatisticOption | null>();

  constructor() {
    effect(() => {
      this.selectedStatisticsCode.set(this.selectedStatistics()[this.groupCode()]);
    });
  }

  statisticDataFiltered = computed(() => {
    const selections = this.selectedStatistics();

    // Extract statistic codes once for better performance
    const selectedCodes = Object.values(selections)
      .filter(sv => sv != null)
      .map(sv => sv!.statisticCode);

    // For subsequent groups, filter based on previous selections
    return this.statisticDataList().filter(statistic => {
      // Show statistics with no dependencies
      if (!statistic.requiresAnyOf || statistic.requiresAnyOf.length === 0) {
        return true;
      }

      // Check if ANY required value is in selected codes (OR logic)
      return statistic.requiresAnyOf.some(required =>
        selectedCodes.includes(required)
      );
    });
  });

  selectStatistic(data: StatisticOption) {
    this.selectedStatisticsCode.set(data);
    this.selectedStatisticCodeChanged.emit(data);
  }
}
